export const truncateText = (textDiv, maxLines, originalTextDivHTML) => {
	if (!originalTextDivHTML)
		throw new Error(
			"Error in TexTruncate, because originalTextDivHTML is mandatory"
		);

	textDiv.innerHTML = originalTextDivHTML;
	splitLines(textDiv);
	truncateLastLineElementText(textDiv, maxLines);
	joinLines(textDiv);

	const resizeListener = () => {
		window.removeEventListener("resize", resizeListener);

		textDiv.innerHTML = originalTextDivHTML;
		splitLines(textDiv);
		truncateLastLineElementText(textDiv, maxLines);
		joinLines(textDiv);

		setTimeout(() => {
			window.addEventListener("resize", resizeListener, { passive: true });
		}, 300);
	};
	window.addEventListener("resize", resizeListener);
};

function getElementToSplitOrJoin(textDiv) {
	let elementToSplit = textDiv.querySelector("[data-advisorAdvice]")
		? textDiv.querySelector("[data-advisorAdvice]")
		: textDiv.querySelector("p")
		? textDiv.querySelector("p")
		: textDiv;

	if (elementToSplit.querySelector("span")) {
		elementToSplit = elementToSplit.querySelector("span");
	}

	return elementToSplit;
}

function splitLines(textDiv) {
	let elementToSplit = getElementToSplitOrJoin(textDiv);

	const brRegex = /<br>/g;
	// replace all the <br> with a <br> and spaces, to split by every space
	elementToSplit.innerHTML = elementToSplit.innerHTML
		.replace(brRegex, " <br> ")
		.split(/\s/)
		.map((word) => {
			if (word === "<br>") {
				return word;
			}

			return `<split>${word}</split>`;
		})
		.join(" ");
}

function constructLineList(textDiv) {
	const lines = [];
	const words = textDiv.querySelectorAll("split");

	let line = [];
	let lastTop;

	words.forEach((word) => {
		if (word.offsetTop !== lastTop) {
			// If the offset top of the current word is not the last offset top that means we have a new line, and the last top should be equel to the current word's offset top
			lastTop = word.offsetTop;
			line = [];
			lines.push(line);
		}
		line.push(word);
	});
	return lines;
}

function joinLines(textDiv) {
	const elementToJoin = getElementToSplitOrJoin(textDiv);
	elementToJoin.innerHTML = elementToJoin.innerHTML
		.replaceAll("<split>", "")
		.replaceAll("</split>", "");
}

function getLastElementTextAndLength(textDiv, maxLines) {
	const lines = constructLineList(textDiv);
	const lastLineIndex = maxLines - 1;
	let lastShownLine = lines[lastLineIndex];
	// If the last line length is equel to 1 that means the line will only contain the 3 dots
	// If that's the case, the last line the last line will be the previous line
	if (!lastShownLine) return;

	const lastShownItem = lastShownLine[lastShownLine.length - 1];
	return lastShownItem;
}

function truncateLastLineElementText(textDiv, maxLines) {
	if (!getLastElementTextAndLength(textDiv, maxLines)) return;
	const lastShownItem = getLastElementTextAndLength(textDiv, maxLines);
	const lastShowItemInnerText = lastShownItem.innerText.trim();
	const lastShowItemInnerTextLength = lastShowItemInnerText.length;
	const lastShownItemLastChar =
		lastShownItem.innerText[lastShowItemInnerTextLength - 1];
	const isAlphabeticCharacter = /[a-zA-Z]$/.test(lastShownItemLastChar);

	if (isAlphabeticCharacter) {
		lastShownItem.innerText = lastShownItem.innerText + "...";
		return;
	}

	const lastShowItemSlicedInnerText = lastShownItem.innerText.slice(
		0,
		lastShowItemInnerTextLength - 1
	);
	lastShownItem.innerText = lastShowItemSlicedInnerText + "...";
}
